import { Avatar, Dropdown, Layout, Space } from 'antd';
import { MenuProps } from 'antd/lib';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import LanguageSwitcher from '../components/LanguageSwitcher';
import { logout, selectUser } from '../redux/auth/authSlice';
import { selectTheme } from '../redux/config/configSlice';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { persistor } from '../redux/store';

import { selectShift } from '@/redux/data/dataSlice';
import toaster from '@/toaster';
import { CiLogout } from 'react-icons/ci';
import classes from './Header.layout.module.css';

const { Header: HeaderComponent } = Layout;

const Header = ({ activeMenuTab }: { activeMenuTab: any }) => {
  const { t } = useTranslation();
  const theme = useAppSelector(selectTheme);
  const user = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const openedShift = useAppSelector(selectShift);

  const handleLogout = () => {
    if (openedShift) {
      return toaster.error(t('SHIFT_NOT_CLOSED'));
    }

    persistor.purge();
    dispatch(logout());
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: '3',
      icon: <CiLogout />,
      label: t('logout'),
    },
  ];

  const handleUserMenuItemClick: MenuProps['onClick'] = (e) => {
    const { key } = e;
    if (key === '3') {
      handleLogout();
    }
  };

  return (
    <>
      <HeaderComponent className={classes.header}>
        <h1 className={classes.title}>{activeMenuTab?.label}</h1>

        <Space size={20} className="notPrintable">
          <LanguageSwitcher />

          <Dropdown
            trigger={['click']}
            menu={{
              items: userMenuItems,
              onClick: handleUserMenuItemClick,
            }}
          >
            <Avatar
              src={user?.avatar}
              size="large"
              style={{
                backgroundColor: theme === 'light' ? '#000' : '#fff',
                cursor: 'pointer',
              }}
            >
              {!user?.avatar && user?.name?.[0]?.toUpperCase()}
            </Avatar>
          </Dropdown>
        </Space>
      </HeaderComponent>
    </>
  );
};

export default Header;

Header.propTypes = {
  activeMenuTab: PropTypes.object,
};
